import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {
  MdHomeFilled,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "react-icons/md";
import {
  Link,
  Routes,
  Route,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useState, useEffect } from "react";
// import StepperDetail from "./StepperDetail";
import StepperMui from "./StepperMui";
import StepperDetail from "./StepperDetail";
import axios from "axios";
import ConfirmModal from "../../components/ConfirmModal";
import Loading from "../../components/Loading";

export default function HorizontalNonLinearStepper({
  stepData,
  steps,
  correctiveData,
  downloadData,
  activeStep,
  firstStep,
}) {
  let navigate = useNavigate();
  const [fileUpload, setFileUpload] = useState([]);
  const [submitFiles, setSubmitFiles] = useState([]);
  const [fileData, setFileData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  // Loading 핸들러
  const [visible, setVisible] = useState(false);
  const closeModal = () => {
    setShowModal(false);
  };
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);

  const closeModal2 = () => {
    setShowModal2(false);
  };
  const closeModal3 = () => {
    setShowModal3(false);
  };
  // const fileDownloadHandler = () => {};
  const fileUploadHandler = (data) => async (event) => {
    setVisible(true);
    let tempObj = {};
    tempObj.parentType = data.id;
    tempObj.name = event.target.files[0].name;
    tempObj.required = data.state;
    // setFileData((state) => {
    //   return [...state, tempObj];
    // });
    // setFileUpload((state) => {
    //   return [...state, event.target.files[0]];
    // });
    // setFileUpload(event.target.files[0]);
    const formData = new FormData();
    formData.append("files", event.target.files[0]);
    formData.append("docs", JSON.stringify([tempObj]));
    try {
      const response = await axios.post(
        `/api/apply-proc/${state.id}/docs/owrite`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setVisible(false);
      setShowModal3(true);
      // setFileUpload([]);
    } catch (err) {
      setVisible(false);
      console.log("err", err);
    }
  };

  // const deleteFile = (el) => () => {
  //   let filteredFilesList = fileUpload.filter((e) => e.name !== el.name);
  //   let filteredFilesDataList = fileData.filter((e) => e.name !== el.name);
  //   setFileUpload(filteredFilesList);
  //   setFileData(filteredFilesDataList);
  // };
  const { state } = useLocation();
  const fileSubmitHandler = async () => {
    // if (firstStep > activeStep) {
    //   return setShowModal(true);
    // }
    // const filteredDownloadData = downloadData.filter((el) => el.state === 2);
    // const filteredFiles = fileData.filter((el) => el.required === 2);
    // if (filteredDownloadData.length !== filteredFiles.length) {
    //   return setShowModal2(true);
    // } else {
    //   for (let i = 0; i < filteredDownloadData.length; i++) {
    //     let duplicated = 0;
    //     for (let j = 0; j < filteredFiles.length; j++) {
    //       if (filteredDownloadData[i].id === filteredFiles[j].parentType) {
    //         duplicated += 1;
    //       }
    //     }
    //     if (duplicated > 1) {
    //       return setShowModal2(true);
    //     }
    //   }
    // }
    setVisible(true);
    const formData = new FormData();
    for (let i = 0; i < fileUpload.length; i++) {
      formData.append("files", fileUpload[i]);
    }
    let jsonDocs = JSON.stringify(fileData);
    formData.append("docs", jsonDocs);
    try {
      const response = await axios.post(
        `/api/apply-proc/${state.id}/docs/owrite`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setVisible(false);
      setShowModal3(true);
      setFileUpload([]);
    } catch (err) {
      setVisible(false);
      console.log("err", err);
    }
  };
  useEffect(() => {
    let tabTitle1 = document.querySelector(".tab_title1");
    let tabTitle2 = document.querySelector(".tab_title2");
    // tabTitle1.addEventListener("click", () => {
    //   tabTitle1.style.borderTop = "1px solid #bbb";
    //   tabTitle1.style.borderLeft = "1px solid #bbb";
    //   tabTitle1.style.borderRight = "1px solid #bbb";
    //   tabTitle1.style.background = "white";
    //   tabTitle2.style.background = "#f3f3f3";
    //   tabTitle2.style.border = "none";
    // });
    // tabTitle2.addEventListener("click", () => {
    //   tabTitle2.style.borderTop = "1px solid #bbb";
    //   tabTitle2.style.borderLeft = "1px solid #bbb";
    //   tabTitle2.style.borderRight = "1px solid #bbb";
    //   tabTitle2.style.background = "white";
    //   tabTitle1.style.background = "#f3f3f3";
    //   tabTitle1.style.border = "none";
    // });
    const getSubmitFiles = async () => {
      try {
        const res = await axios.get(`/api/task-apply-form-attrs`, {
          params: {
            targetId: state.taskGroupId,
            applyProcessId: state.id,
            confVersion: state.confVersion,
          },
        });
        setSubmitFiles(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    getSubmitFiles();
  }, []);

  const ContA = (props) => {
    let navigate = useNavigate();
    return (
      <div className="my_commitee_inout">
        {/* start */}
        <Routes>
          <Route
            path=":id"
            element={
              <StepperDetail
                steps={steps}
                activeStep={activeStep}
                firstStep={firstStep}
              />
            }
          />
        </Routes>
        {correctiveData?.length > 0 ? (
          <div className="row_bbs bbs_wrap">
            <table className="table_wrap">
              <thead>
                <tr>
                  <th style={{ flex: "1" }}>글제목</th>
                  <th style={{ flex: "0.3" }}>진행단계</th>
                  <th style={{ flex: "0.3" }}>날짜</th>
                  <th style={{ flex: "0.3" }}>조치만료일</th>
                </tr>
              </thead>
              <tbody>
                {correctiveData.map((e, idx) => {
                  // state 에 따른 분류필요
                  return (
                    <tr key={idx} className="tr_hover">
                      <td style={{ cursor: "pointer", flex: "1" }}>
                        <p
                          onClick={() => {
                            navigate(`/stepper/${e.id}`, { state });
                          }}
                        >
                          {e.title}
                        </p>
                      </td>
                      <td style={{ flex: "0.3" }} className="date_bbs">
                        {e.state === 1 ? "정상" : null}
                        {e.state === 11 ? "시정조치요청" : null}
                        {e.state === 12 ? "신청기관조치완료" : null}
                        {e.state === 21 ? "협회확인" : null}
                        {e.state === 29 ? "반려" : null}
                        {/* 이의불만분쟁 */}
                        {/* {e.state === 91 ? "이의불만제시" : null} */}
                        {e.state === 91 ? "조치결과 제시" : null}
                        {/* // 조치결과 안내 */}
                        {/* {e.state === 92 ? "이의불만/분쟁처리중" : null}  */}
                        {e.state === 92 ? "조치결과 처리중" : null}
                        {/* // 조치결과 처리중  */}
                        {/* {e.state === 93 ? "분쟁처리완료" : null} */}
                        {e.state === 93 ? "조치결과 처리완료" : null}
                        {/* {e.state === 94 ? "인증위원회 제시" : null}
                        {e.state === 95 ? "인증위원회 처리중" : null}
                        {e.state === 96 ? "인증위원회 분쟁처리 완료" : null} */}
                      </td>
                      <td style={{ flex: "0.3" }} className="date_bbs">
                        {e.createAt?.substring(0, 11).replace(/-/g, ".")}
                      </td>

                      <td style={{ flex: "0.3" }} className="date_bbs">
                        {e.limitDate?.replace(/-/g, ".")}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div style={{ margin: "2rem 0" }}>
              <div></div>
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/stepper", { state });
                    }}
                    className="btn_color"
                  >
                    목록
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <span
            style={{ padding: "30px", fontSize: "1.2rem", fontWeight: "bold" }}
          >
            {state?.taskGroup?.type === 9 ? "조치결과" : "시정조치"}내역이
            없습니다.
          </span>
        )}

        {/* end */}
      </div>
    );
  };

  const ContB = (props) => {
    let navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    return (
      <>
        <div className="my_commitee_inout">
          {visible && <Loading visible={visible} />}
          {downloadData.length > 0 ? (
            <div className="my_commitee_inout_wrap">
              <table className="table_wrap">
                <thead>
                  <tr>
                    <th>평가서 및 체크리스트</th>
                    {/* <th>업로드/변경날짜</th> */}
                    <th>다운로드</th>
                    <th>파일선택</th>
                  </tr>
                </thead>
                <tbody>
                  {downloadData.map((e) => {
                    let testColor = e.exist === 1 ? "dodgerBlue" : "grey";
                    let testCursor = e.exist === 1 ? "pointer" : "not-allowed";
                    return (
                      <tr key={e.id}>
                        <td className="">{e.name}</td>
                        {/* <td className="">
                          {e.updateAt?.substring(0, 11).replace(/-/g, ".")}
                        </td> */}
                        <td className="">
                          <button
                            className="btn_color"
                            style={{
                              backgroundColor: testColor,
                              border: "0px solid black",
                              cursor: testCursor,
                            }}
                          >
                            {e.downloadTarget !== 1 ? (
                              <a
                                href={`/api/apply-proc/${state.id}/doc/${e.id}`}
                                style={{
                                  cursor: testCursor,
                                  wordBreak: "keep-all",
                                  color: "white",
                                  textAlign: "center",
                                  width: "110px",
                                  height: "40px",
                                  paddingTop: "8px",
                                }}
                                download
                              >
                                파일다운로드
                              </a>
                            ) : null}
                          </button>
                        </td>
                        <td className="">
                          <div
                            className="input_wrap file_input_wrap"
                            style={{
                              backgroundColor: "white",
                              height: "34px",
                              marginLeft: "20px",
                            }}
                          >
                            {e.uploadTarget !== 1 ? (
                              <>
                                <input
                                  className="input_box file_input"
                                  type="file"
                                  id={e.id}
                                  style={{
                                    visibility: "hidden",
                                    width: "20px",
                                  }}
                                  comment={e.description}
                                  onChange={fileUploadHandler(e)}
                                />
                                <label
                                  htmlFor={e.id}
                                  className="file_label"
                                  style={{
                                    height: "100%",
                                    borderRadius: "3px",
                                    padding: "0 1rem",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    wordBreak: "keep-all",
                                    marginLeft: "25px",
                                  }}
                                >
                                  파일업로드
                                </label>
                              </>
                            ) : (
                              <label
                                htmlFor={e.id}
                                className="file_label"
                                style={{
                                  height: "100%",
                                  borderRadius: "3px",
                                  backgroundColor: "grey",
                                  cursor: "not-allowed",
                                  padding: "0 1rem",
                                  fontWeight: "600",
                                  fontSize: "14px",
                                  wordBreak: "keep-all",
                                  marginLeft: "25px",
                                }}
                              >
                                파일업로드
                              </label>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <span
              style={{
                padding: "30px",
                fontSize: "1.2rem",
                fontWeight: "bold",
              }}
            >
              데이터가 없습니다
            </span>
          )}
        </div>
      </>
    );
  };
  const ContC = (props) => {
    let navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    return (
      <>
        <div className="my_commitee_inout">
          {visible && <Loading visible={visible} />}
          {submitFiles.length > 0 ? (
            <div className="my_commitee_inout_wrap">
              <table className="table_wrap">
                <thead>
                  <tr>
                    <th>파일명</th>
                    <th>다운로드</th>
                  </tr>
                </thead>
                <tbody>
                  {submitFiles.map((e) => {
                    return (
                      <tr key={e.id}>
                        <td className="">{e.name}</td>
                        {/* <td className="">
                          {e.updateAt?.substring(0, 11).replace(/-/g, ".")}
                        </td> */}
                        <td className="">
                          <button
                            className="btn_color"
                            style={{
                              border: "0px solid black",
                            }}
                          >
                            <a
                              href={`/api/apply-proc/${state.id}/doc/${e.id}`}
                              style={{
                                wordBreak: "keep-all",
                                color: "white",
                                textAlign: "center",
                                width: "110px",
                                height: "40px",
                                paddingTop: "8px",
                              }}
                              download
                            >
                              파일다운로드
                            </a>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <h3>데이터가 없습니다</h3>
          )}
        </div>
      </>
    );
  };
  const Tab1 = (props) => {
    return (
      <div>
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            props.onChangeActivetab();
          }}
          className="tab_title tab_title1"
          style={{
            backgroundColor: Activetab === "tabA" ? "dodgerBlue" : "#f3f3f3",
            color: Activetab === "tabA" ? "white" : "none",
          }}
        >
          {state?.taskGroup?.type === 9 ? "조치결과" : "시정조치내역"}
        </a>
      </div>
    );
  };
  const Tab2 = (props) => {
    return (
      <div>
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            props.onChangeActivetab();
          }}
          style={{
            backgroundColor: Activetab === "tabB" ? "dodgerBlue" : "#f3f3f3",
            color: Activetab === "tabB" ? "white" : "none",
          }}
          className="tab_title tab_title2"
        >
          제출/제공 문서
        </a>
      </div>
    );
  };
  const Tab3 = (props) => {
    return (
      <div>
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            props.onChangeActivetab();
          }}
          style={{
            backgroundColor: Activetab === "tabC" ? "dodgerBlue" : "#f3f3f3",
            color: Activetab === "tabC" ? "white" : "none",
          }}
          className="tab_title tab_title3"
        >
          신청서 첨부파일
        </a>
      </div>
    );
  };
  const [Activetab, Activetabset] = useState("tabA");
  let content = null;
  if (Activetab === "tabA") {
    content = <ContA />;
  } else if (Activetab === "tabB") {
    content = <ContB />;
  } else if (Activetab === "tabC") {
    content = <ContC />;
  }
  //end

  return (
    <Box sx={{ width: "100%" }}>
      {showModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"진행단계"}
          content={`이전단계는 수정이 불가합니다.`}
        />
      ) : null}
      {showModal2 ? (
        <ConfirmModal
          closeModal={closeModal2}
          modalTitle={"다운로드"}
          content={`필수파일, 업로드파일을 다시한번 확인해주세요.`}
        />
      ) : null}
      {showModal3 ? (
        <ConfirmModal
          closeModal={closeModal3}
          modalTitle={"제출하기"}
          content={`파일업로드가 완료되었습니다.`}
        />
      ) : null}
      <div>
        <React.Fragment>
          <Typography>
            <div className="tab_wrap">
              <div className="tab_btns" style={{ marginBottom: "3vh" }}>
                <Tab1
                  onChangeActivetab={() => {
                    Activetabset("tabA");
                  }}
                />
                <Tab2
                  onChangeActivetab={() => {
                    Activetabset("tabB");
                  }}
                />
                <Tab3
                  onChangeActivetab={() => {
                    Activetabset("tabC");
                  }}
                />
              </div>
              <div className="tab_conts" style={{ margin: "0 0" }}>
                {content}
              </div>
            </div>
          </Typography>
        </React.Fragment>
      </div>
      {visible && <Loading visible={visible} />}
    </Box>
  );
}
